import { api } from '@/services'
export function fetchBranchesAsAdmin(params) {
    return api.get('/admin/branch/list', { params: params }) 
}
export function fetchBranch(id) {
    return api.get(`/admin/branch/show/${id}`) 
}
export function deleteBranch(id) {
    return api.delete(`/admin/branch/delete/${id}`) 
}
export function create(body) {
    return api.post('/admin/branch/create', body)
}
export function update(body) {
    return api.put('/admin/branch/update', body)
}

// Self-service endpoints: the real estate managing its own branches. Scoped by the token on the
// backend, so none of these take a realEstateId.
export function fetchOwnBranch(id) {
    return api.get(`/web/branch/show/${id}`)
}
export function createOwnBranch(body) {
    return api.post('/web/branch/create', body)
}
export function updateOwnBranch(body) {
    return api.put('/web/branch/update', body)
}
export function deleteOwnBranch(id) {
    return api.delete(`/web/branch/delete/${id}`)
}
